(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileOnly = window.matchMedia('(max-width: 768px)');
  let announcement = '';
  if (mobileOnly.matches) {
    announcement = document.querySelector('.announcement-bar-mobile');
  } else {
    announcement = document.querySelector('.announcement-bar-desktop');
  }

  (function () {
    var header = document.querySelector('header.site-header');
    var root = document.querySelector(':root');
    header && root && root.style.setProperty('--header-height', header.offsetHeight + 'px');
    announcement && root && root.style.setProperty('--announcement-bar-height', announcement.offsetHeight + 'px');

    function reCalculate() {
      let mobileOnly = window.matchMedia('(max-width: 768px)');
      let announcement = '';
      if (mobileOnly.matches) {
        announcement = document.querySelector('.announcement-bar-mobile');
      } else {
        announcement = document.querySelector('.announcement-bar-desktop');
      }
      var header = document.querySelector('header.site-header');
      var root = document.querySelector(':root');
      header && root && root.style.setProperty('--header-height', header.offsetHeight + 'px');
      announcement && root && root.style.setProperty('--announcement-bar-height', announcement.offsetHeight + 'px');
    }

    window.addEventListener(
      'resize',
      function () {
        return requestAnimationFrame(reCalculate);
      },
      true
    );

    reCalculate();
  })();

  (function () {
    const header = document.querySelector('header.site-header');
    const announcementBar = document.querySelector('.announcement-bar');

    if (!header) return;

    const headerHeight = header.offsetHeight;
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

    const setBodyPadding = function () {
      var height = headerHeight;
      if (announcementHeight) {
        height = announcementBar.offsetHeight + headerHeight;
      }
      document.body.style.paddingTop = height + 'px';
    };

    const removeBodyPadding = function () {
      document.body.style.paddingTop = '';
    };

    const onScroll = function () {
      if (window.scrollY > announcementHeight) {
        document.body.classList.add('header-fixed');
        return setBodyPadding();
      }

      document.body.classList.remove('header-fixed');
      removeBodyPadding();
    };

    document.querySelectorAll('.site-header--tools__search summary').forEach(function (el) {
      el.addEventListener('click', function () {
        if (!el.parentElement.hasAttribute('open'))
          return document.querySelector('body').classList.add('header-search-fixed');

        document.querySelector('body').classList.remove('header-search-fixed');
      });
    });

    document.addEventListener('scroll', onScroll);
  })();

  // Toggle menu close when clicking megamenu links for a second time
  (function () {
    var navButtons = document.querySelectorAll('button.site-header--navigation__list-item');

    function toggleReset() {
      navButtons.forEach(function (button) {
        var trigger = button.closest('.site-header--navigation__dropdown-trigger');
        trigger.classList.remove('active');
        trigger.classList.remove('menu-hidden');
      });
    }

    function toggleMenu(e) {
      var trigger = e.target.closest('.site-header--navigation__dropdown-trigger');
      var dropdown = trigger.querySelector('.site-header--navigation__dropdown-content');

      if (!trigger) return;

      if (trigger.classList.contains('active') || window.getComputedStyle(dropdown).opacity === '1') {
        trigger.classList.remove('active');
        trigger.classList.add('menu-hidden');
      } else {
        trigger.classList.add('active');
        trigger.classList.remove('menu-hidden');
      }
    }

    navButtons.forEach(function (button) {
      button.addEventListener('click', toggleMenu);
      button.addEventListener('mouseenter', toggleReset);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-like-and-viewed"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
